import { Link } from 'react-router-dom'
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import DataTable from 'react-data-table-component'
import React, { Component } from 'react'

import { dateToString } from '../../actions/util'
import { handleError } from '../../actions/handle-error'
import { toastError, toastSuccess } from '../../actions/toast'
import api from '../../actions/api'
import Loading from '../../components/loading'
import Widget from '../../components/widget'

class FinancialMovement extends Component {
  constructor() {
    super()
    this.onDeleteItem = this.onDeleteItem.bind(this)
    this.onConfirmDelete = this.onConfirmDelete.bind(this)

    this.state = {
      loading: false,
      data: [],
      modal: false,
      totalRows: 0,
      page: 1,
      perPage: 10,
      itemDeleteName: null,
      itemDeleteId: null,
      actions: [
        {
          name: 'Nova Antecipação',
          class_btn: 'btn-success',
          class_collumn: 'col col-md-3 m-1',
          route: '/receivables-antecipations/new'
        }
      ]
    }
    this.paginationOptions = { rowsPerPageText: 'Itens por página', rangeSeparatorText: 'de' };

    this.columns = [
      {
        name: 'Data Empréstimo',
        selector: 'date_format',
      },
      {
        name: 'Nome',
        selector: 'name',
      },
      {
        name: 'Ações',
        cell: (item) => (
          <div>
            <Link to="#">
              <i className="material-icons text-danger rtd_button" onClick={(e) => this.onConfirmDelete(item)}>delete_forever</i>
            </Link>
          </div>
        ),
        button: true,
      },
    ]
  }

  async componentDidMount() {
    await this.getReceivablesAntecipations();
  }

  getReceivablesAntecipations = async () => {
    let antecipations = []
    this.setState({ loading: true })

    await api.get(`receivables-antecipations`)
      .then(result => {
        antecipations = result

        antecipations.data = result.data.map(movement => ({
          ...movement,
          date_format: dateToString(movement.date),
        }))
      })
      .catch(error => {
        toastError(handleError(error));
      })

    this.setState({
      data: antecipations.data,
      totalRows: parseInt(antecipations.total),
      loading: false,
    });
  }

  onConfirmDelete(item) {
    this.setState({ modal: true, itemDeleteName: item.name, itemDeleteId: item.id })
  }

  onDeleteItem = async () => {
    const { itemDeleteId } = this.state;

    await api.delete(`receivables-antecipations/${itemDeleteId}`)
      .then(() => {
        this.getReceivablesAntecipations();
        toastSuccess('Registro removido com sucesso!');
        this.setState({ modal: false, itemDeleteId: null, itemDeleteName: null })
      })
      .catch(error => {
        toastError(handleError(error));
      })
  }

  handleRowClicked = reg => {
    this.props.history.push(`/receivables-antecipations/${reg.id}`)
  }

  handlePageChange = async page => {
    await this.setState({ page: page });
    this.getReceivablesAntecipations()
  }

  handlePerRowsChange = async (perPage, ) => {
    await this.setState({ perPage, });
    this.getReceivablesAntecipations()
  }

  render() {
    return (
      <Widget title="Antecipação Financeira" actions={this.state.actions} line={false}>
        <DataTable
          columns={this.columns}
          data={this.state.data}
          progressPending={this.state.loading}
          pointerOnHover
          highlightOnHover
          noDataComponent="Nenhum registro encontrado"
          onRowClicked={this.handleRowClicked}
          progressComponent={<Loading />}
          // overflowYOffset="500px"
          pagination
          paginationServer
          paginationTotalRows={this.state.totalRows}
          paginationComponentOptions={this.paginationOptions}
          onChangeRowsPerPage={this.handlePerRowsChange}
          onChangePage={this.handlePageChange}
        />

        <Modal
          isOpen={this.state.modal}
          wrapClassName="modal-danger"
          size="default">
          <ModalHeader toggle={this.toggle}>Deletar Registro</ModalHeader>
          <ModalBody>
            Deseja excluir {this.state.itemDeleteName}?
            </ModalBody>
          <ModalFooter>
            <button className="btn btn-success col-4" onClick={this.onDeleteItem}>
              Sim
              </button>
            <button className="btn btn-success" onClick={event => this.setState({ modal: false, itemDeleteName: null })}>
              Cancelar
              </button>
          </ModalFooter>
        </Modal>
      </Widget >
    )
  }
}

export default FinancialMovement